import React, { PropTypes } from 'react'
import { Link } from 'react-router'
import { Tabs, Tab } from 'material-ui/Tabs'
import { findIndex } from 'lodash'

const TabsProvider = ({ pathname, tabs, styles = {} }) => (
// @ts-ignore
  <div style={styles.container}>
    <Tabs
// @ts-ignore
      style={styles.tabs}
// @ts-ignore
      value={findIndex(tabs, tab => pathname?.toLowerCase() === tab.path?.toLowerCase())}
// @ts-ignore
      inkBarStyle={styles.inkBarStyle}
    >
      {tabs.map((tab, index) => (
        <Tab
// @ts-ignore
          style={styles.tab}
          key={index}
          value={index}
          label={tab.label}
          containerElement={
            <Link to={tab.path} />
          }
        />
      ))}
    </Tabs>
  </div>
)

// @ts-ignore
TabsProvider.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
  })).isRequired
}

export default TabsProvider
